import { Button, styled } from '@mui/material';
export const WrapButton = styled(Button)(({ theme }) => ({
    color: theme.palette.action.active,
    justifyContent: 'flex-start',
    padding: 0,
}));
